module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-20.186e17c7.png";